// src/components/AdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  console.log('🔍 AdminRoute check - User:', user);
  console.log('🔍 AdminRoute check - isAdmin:', user?.isAdmin);
  console.log('🔍 AdminRoute check - role:', user?.role);
  
  // ✅ Show loading while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }
  
  // ✅ Check if user is logged in
  if (!user) {
    console.log('❌ AdminRoute: No user found, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  // ✅ ENHANCED: Check both isAdmin and role properties
  const isAdmin = user.isAdmin || user.role === 'admin';
  
  if (!isAdmin) {
    console.log('❌ AdminRoute: User is not admin, redirecting to dashboard');
    console.log('❌ AdminRoute: User object:', user);
    return <Navigate to="/dashboard" replace />;
  }
  
  console.log('✅ AdminRoute: Admin access granted');
  return children;
};

export default AdminRoute;
